const CART_CACHE_KEY = 'cart_cache';
const PRODUCT_CACHE_KEY = 'product_cache';
const CACHE_DURATION = 30000;
const PRODUCT_CACHE_DURATION = 60000;

export const CartCache = {
  getCart: (userId) => {
    try {
      const cache = JSON.parse(localStorage.getItem(CART_CACHE_KEY) || '{}');
      const cached = cache[userId];

      if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
        return cached.data;
      }
      if (cached) {
      } else {
      }
      return null;
    } catch (error) {
      return null;
    }
  },

  setCart: (userId, data) => {
    try {
      const cache = JSON.parse(localStorage.getItem(CART_CACHE_KEY) || '{}');
      cache[userId] = {
        data,
        timestamp: Date.now()
      };
      localStorage.setItem(CART_CACHE_KEY, JSON.stringify(cache));
    } catch (error) {
      console.error('Error setting cart cache:', error);
    }
  },

  clearCart: (userId) => {
    try {
      const cache = JSON.parse(localStorage.getItem(CART_CACHE_KEY) || '{}');
      delete cache[userId];
      localStorage.setItem(CART_CACHE_KEY, JSON.stringify(cache));
    } catch (error) {
      console.error('Error clearing cart cache:', error);
    }
  },

  getProduct: (productId) => {
    try {
      const cache = JSON.parse(localStorage.getItem(PRODUCT_CACHE_KEY) || '{}');
      const cached = cache[productId];

      if (cached && Date.now() - cached.timestamp < PRODUCT_CACHE_DURATION) {
        return cached.data;
      }
      return null;
    } catch (error) {
      return null;
    }
  },

  setProduct: (productId, data) => {
    try {
      const cache = JSON.parse(localStorage.getItem(PRODUCT_CACHE_KEY) || '{}');
      cache[productId] = {
        data,
        timestamp: Date.now()
      };
      localStorage.setItem(PRODUCT_CACHE_KEY, JSON.stringify(cache));
    } catch (error) {
      console.error('Error setting product cache:', error);
    }
  },

  getProductsBulk: (productIds) => {
    const cached = [];
    const toFetch = [];

    productIds.forEach(id => {
      const product = CartCache.getProduct(id);
      if (product) {
        cached.push(product);
      } else {
        toFetch.push(id);
      }
    });

    return { cached, toFetch };
  },

  clearExpired: () => {
    try {
      const cartCache = JSON.parse(localStorage.getItem(CART_CACHE_KEY) || '{}');
      const productCache = JSON.parse(localStorage.getItem(PRODUCT_CACHE_KEY) || '{}');
      const now = Date.now();
      let cartChanges = false;
      let productChanges = false;

      Object.keys(cartCache).forEach(key => {
        if (now - cartCache[key].timestamp > CACHE_DURATION) {
          delete cartCache[key];
          cartChanges = true;
        }
      });

      Object.keys(productCache).forEach(key => {
        if (now - productCache[key].timestamp > PRODUCT_CACHE_DURATION) {
          delete productCache[key];
          productChanges = true;
        }
      });

      if (cartChanges) {
        localStorage.setItem(CART_CACHE_KEY, JSON.stringify(cartCache));
      }
      if (productChanges) {
        localStorage.setItem(PRODUCT_CACHE_KEY, JSON.stringify(productCache));
      }
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
  }
};

setInterval(CartCache.clearExpired, 300000);